var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.59 7.91234L14.3644 9.13789L15.7378 10.5199H8.6365V12.2583H15.7378L14.3644 13.6316L15.59 14.8658L19.0667 11.3891L15.59 7.91234ZM5.15976 5.30478H11.2441V3.56641H5.15976C4.20365 3.56641 3.42139 4.34867 3.42139 5.30478V17.4734C3.42139 18.4295 4.20365 19.2118 5.15976 19.2118H11.2441V17.4734H5.15976V5.30478Z",
    fill: "#EA2424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.182e0de6145607591b4ddb8c73cfc211.svg";
export { ForwardRef as ReactComponent };